export default __webpack_public_path__ + "static/media/promotionTwo.ccd45270.jpg";